module.exports = __webpack_public_path__ + "7169d0058408b84b8cf7c469c96b2ee4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/discover.png
// module id = 515
// module chunks = 0